import TomSelect from "tom-select";
import _ from "lodash";

(function (cash) {
    "use strict";
    window.all_tom_selects = [];

    // Tom Select
    window.tom_select_init = _.debounce(function(){
        if( window.all_tom_selects.length > 0 ){
            cash.each( window.all_tom_selects, function(index,obj){
                if( !cash(obj.input).hasClass('no-refresh') ){
                    obj.destroy();
                }
            });
            window.all_tom_selects = [];
        }

        let get_route = {};

        cash(".tom-select:not(.no-auto-tom)").each(function () {

            if(cash(this).hasClass('tomselected') && ( cash(this).is('input') || cash(this).is('select') ) ){
                return;
            }
            if(cash(this).is('div')){
                return;
            }


            let options = {
                plugins: {
                    dropdown_input: {},
                },
            };

            if (cash(this).data("placeholder")) {
                options.placeholder = cash(this).data("placeholder");
            }

            if (cash(this).attr("multiple") !== undefined) {
                options = {
                    ...options,
                    plugins: {
                        ...options.plugins,
                        remove_button: {
                            title: "Remove this item",
                        },
                    },
                    persist: false,
                    create: true,
                    onDelete: function (values) {
                        return confirm(
                            values.length > 1
                                ? "Are you sure you want to remove these " +
                                      values.length +
                                      " items?"
                                : 'Are you sure you want to remove "' +
                                      values[0] +
                                      '"?'
                        );
                    },
                };

                if (cash(this).data("nousercreate")) {
                    options['create'] = false;
                }
            }

            if (cash(this).data("createoption")) {
                options = {
                    ...options,
                    create: true,
                    maxItems: 1,
                    onDelete: function (values) {
                        return confirm(
                            values.length > 1
                                ? "Are you sure you want to remove these " +
                                    values.length +
                                    " items?"
                                : 'Are you sure you want to remove "' +
                                    values[0] +
                                    '"?'
                        );
                    },
                }
            }

            if (cash(this).data("header")) {
                options = {
                    ...options,
                    plugins: {
                        ...options.plugins,
                        dropdown_header: {
                            title: cash(this).data("header"),
                        },
                    },
                };
            }

            if (cash(this).data("hiddenlist")) {
                options = {
                    ...options,
                    render: {
                        item: function(data, escape) {
                            return '<div class="item-hidden">'+escape(data.text)+'</div>';
                        }
                    },
                };
            }

            if (cash(this).data("checkboxoption")) {
                options = {
                    ...options,
                    plugins: {
                        ...options.plugins,
                        checkbox_options: {},
                    },
                };
            }

            if (cash(this).data("allowEmptyOption")) {
                options = {
                    ...options,
                    allowEmptyOption: true
                };
            }

            if (cash(this).data("initialload")) {
                options = {
                    ...options,
                    valueField: cash(this).data("valuefield"),
                    labelField: cash(this).data("labelfield"),
                    searchField: cash(this).data("searchfield"),
                    items: cash(this).data("value"),
                    load: function(query, callback) {
                        var self = this;
                        if( self.loading > 1 ){
                            callback();
                            return;
                        }
                        var url = cash(self.input).data("loadurl");
                        if(url in get_route){
                            callback(get_route[url]);
                            return;
                        }

                        let token = document.head.querySelector('meta[name="csrf-token"]');
                        fetch(url,{
                            method: "GET",
                            headers: {
                                "X-CSRF-TOKEN": token.content,
                                "X-Requested-With" : "XMLHttpRequest"
                            }
                        })
                            .then(response => response.json())
                            .then(json => {
                                callback(json.results);
                                self.settings.load = null;
                                get_route[url] = json.results;
                            }).then(()=>{
                                if(cash(self.input).attr("multiple") !== undefined){
                                    if(cash(self.input).data("value")){
                                        self.setValue( cash(self.input).data("value").split(',') );
                                    }
                                }else{
                                    if(cash(self.input).data("value")){
                                        self.setValue( cash(self.input).data("value") );
                                    }
                                }

                            }).catch(()=>{
                                callback();
                            });

                    }
                };
                if(cash(this).data("preload")){
                    options['preload'] = true;
                }
            }

            window.all_tom_selects.push(new TomSelect(this, options));
        });
    }, 1000, { 'leading':true ,'trailing': false });

    window.tom_select_init();

    window.getTomSelectByID = function(id){
        let found_tom = null;
        cash(window.all_tom_selects).each( function(index,tom_obj){
            if(tom_obj.inputId == id){
                found_tom = tom_obj;
                return false;
            }
        });
        return found_tom;

    };

})(cash);

// var equipement_rate = new window.TomSelect('#equipement_rate_select',{
//     valueField: 'id',
//     render: {
//         item: function(data, escape) {
//             return '<div>'+escape(data.text)+'</div>';
//         }
//     },plugins: {
//     dropdown_input: {},
// }
// })
// .plugin-dropdown_input .ts-input.focus
// border: 1px solid #d0d0d0;
// .ts-input
// border: 1px solid #d0d0d0;
